module.exports = __webpack_public_path__ + "img/icon-comment.fd52a928.svg";